import { createFileRoute } from '@tanstack/react-router';
import { JourneysSegmentAudiencesHandoff } from '@/pages/workspaces/segments/[segmentId]/audiences/routing';

/**
 * The `journeys` URL the embedded app's segment tab bar links to for Ad Audiences. It forwards to the
 * tab's own URL with the sentinel kept, and that route resolves it. So no resolver runs here.
 *
 * No search validation: the forward carries the query to the tab's own route, which validates it.
 */
function JourneysSegmentAudiencesRoute() {
  const { segmentId } = Route.useParams();

  return <JourneysSegmentAudiencesHandoff segmentId={segmentId} />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/journeys/segments/$segmentId/audiences')({
  component: JourneysSegmentAudiencesRoute,
});
